module.exports = __webpack_public_path__ + "media/images/world-map-328bf43db0c24eefe1f4260073d7c241.svg";